<div class="gutter">
	<div class="flx-col"> 
		
		<div class="contact flx-dynamic flx-btwn-strt-md">
			<div class="gutter gutter-v-half flx-dynamic-50 flx-col flx-gap-default">
				<h2 *ngIf="pageTitle">{{ pageTitle }}</h2>
				<app-ve [content]="pageContent"></app-ve>
				<div class="flx-dynamic flx-gap-default-forced" *ngIf="localeId == 'pl'">
					<div class="brd-left w-50" *ngIf="isLogged">
						<h4>Paweł Bolibok</h4>
						<p i18n="@@salesman">specjalista ds. sprzedaży</p>
						<p>tel +48 505 254 069</p>
					</div>
				</div>
				<div class="flx-dynamic flx-gap-default-forced" *ngIf="localeId == 'en'">
					<div class="brd-left w-50">
						<h4>Karolina Puszkarska</h4>
						<p i18n="@@salesman">specjalista ds. sprzedaży</p>
						<p>tel +48 889 468 260</p>
					</div>
					<div class="brd-left w-50" *ngIf="isLogged">
						<h4>Kamil Brzyski</h4>
						<p i18n="@@salesman">specjalista ds. sprzedaży</p>
						<p>tel +48 668 016 118</p>
					</div>
				</div>
				<div class="flx-dynamic flx-gap-default-forced" *ngIf="localeId == 'de'">
					<div class="brd-left w-50">
						<h4>Grzegorz Furgał</h4>
						<p i18n="@@salesman">specjalista ds. sprzedaży</p>
						<p>tel +48 696 393 960</p>
					</div>
					<div class="brd-left w-50">
						<h4>Tomasz Lemieszek</h4>
						<p i18n="@@salesman">specjalista ds. sprzedaży</p>
						<p>tel +48 668 712 677</p>
					</div>
				</div>
				<div class="flx-dynamic flx-gap-default-forced" *ngIf="localeId == 'fr'">
					<div class="brd-left w-50">
						<h4>Karolina Misterek</h4>
						<p i18n="@@salesman">specjalista ds. sprzedaży</p>
						<a href="tel:48574950870">tel +48 575 480 930</a>
					</div>
				</div>
				<div class="flx-dynamic flx-gap-default-forced" *ngIf="localeId == 'it'">
					<div class="brd-left w-50">
						<h4>Tomasz Lemieszek</h4>
						<p i18n="@@salesman">specjalista ds. sprzedaży</p>
						<p>tel +48 668 712 677</p>
					</div>
				</div>
				<div class="flx-dynamic flx-gap-default-forced" *ngIf="localeId == 'es'">
					<div class="brd-left w-50">
						<h4>Karolina Puszkarska</h4>
						<p i18n="@@salesman">specjalista ds. sprzedaży</p>
						<p>tel +48 889 468 260</p>
					</div>
				</div>
			</div>
			<div class="contact-form-wrap gutter gutter-v-half flx-dynamic-50 flx-col flx-gap-default">
				<h2 i18n>Napisz do nas</h2>
				<p i18n>Jeżeli nie znalazłeś w sklepie informacji, których szukasz, po prostu napisz do nas. Chcesz zapytać o produkt czy producenta? Napisz do nas!</p>
				
				<form [formGroup]="form" novalidate class="flx-col">
					<input type="hidden" formControlName="namesurname">
					<mat-form-field appearance="outline">
					  <mat-label i18n="@@subject">Rodzaj pytania</mat-label>
					  <mat-select formControlName="subject">
					  <mat-option *ngFor="let subject of subjects" [value]="subject.value">
						  {{ subject.viewValue }}
					  </mat-option>
					  </mat-select>
					  <mat-error i18n="@@error_req">To pole jest wymagane</mat-error>
				  </mat-form-field>
					<mat-form-field appearance="outline" *ngIf="withvin">
						<mat-label i18n="@@vin_cnt">VIN (numer nadwozia) przyczepy</mat-label>
						<input matInput formControlName="vin" i18n-placeholder>
					</mat-form-field>
					<mat-form-field appearance="outline">
					  <mat-label i18n="@@email">Adres e-mail</mat-label>
					  <input matInput formControlName="email" i18n-placeholder>
					  <mat-error i18n>To pole musi być poprawnym adresem e-mail</mat-error>
					</mat-form-field>
					<div class="flx-dynamic flx-gap-default">
					<mat-form-field appearance="outline">
					  <mat-label i18n="@@namesurname">Imię i nazwisko</mat-label>
					  <input matInput formControlName="name" i18n-placeholder>
					  <mat-error i18n="@@error_req">To pole jest wymagane</mat-error>
					</mat-form-field>
					<mat-form-field appearance="outline">
					  <mat-label i18n="@@cmpn_name">Nazwa firmy</mat-label>
					  <input matInput formControlName="company" i18n-placeholder>
					  <mat-error i18n="@@error_req">To pole jest wymagane</mat-error>
					</mat-form-field>
					</div>
					<!-- <mat-form-field appearance="outline">
					  <mat-label i18n>Temat wiadomości</mat-label>
					  <input matInput formControlName="subject" i18n-placeholder>
					  <mat-error i18n="@@error_req">To pole jest wymagane</mat-error>
					</mat-form-field> -->
					<div class="flx-dynamic flx-gap-default">
					  <mat-form-field appearance="outline">
						  <mat-label i18n="@@country">Kraj</mat-label>
						  <mat-select formControlName="country">
						  <mat-option *ngFor="let country of countries" [value]="country.value">
							  {{ country.viewValue }}
						  </mat-option>
						  </mat-select>
						  <mat-error i18n="@@error_req">To pole jest wymagane</mat-error>
					  </mat-form-field>
					  <mat-form-field appearance="outline">
						<mat-label i18n="@@postcode">Kod pocztowy</mat-label>
						<input matInput formControlName="postcode" i18n-placeholder>
					  </mat-form-field>
				  </div>
					<mat-form-field appearance="outline">
					  <mat-label i18n>Treść wiadomości</mat-label>
					  <textarea matInput formControlName="message" i18n-placeholder></textarea>
					  <mat-error i18n="@@error_req">To pole jest wymagane</mat-error>
					</mat-form-field>
					<div class="rodo-checkbox">
					  <mat-checkbox formControlName="rodo">{{  this.settings.extra_field_2 }} <span (click)="regulations = !regulations" i18n>...czytaj więcej</span></mat-checkbox>
					  <div class="regulations-content" *ngIf="regulations" [innerHtml]="settings.extra_field_3"></div>
					  <mat-error *ngIf="form.controls.rodo.invalid && form.controls.rodo.dirty" i18n>Musisz wyrazić zgodę aby kontynuować</mat-error> 
					</div>

					<div class="rodo-checkbox">
						<mat-checkbox formControlName="newsletter" i18n="@@newsletter">Zapisuję się na newsletter i akceptuję regulamin oraz politykę prywatności. Wyrażam zgodę na przetwarzanie moich danych osobowych przez MARTZ Sp. z o.o. z siedzibą w Świdniku zawartych w wypełnionym formularzu w celach związanych z wysyłką newslettera oraz na kontakt ze mną za pomocą środków komunikacji elektronicznej i z wykorzystaniem podanych przeze mnie danych kontaktowych, w celu marketingu bezpośredniego i w celu przekazywania informacji handlowych.
						</mat-checkbox>
					</div>
			  
				  <p class="info error" *ngIf="res === 2" i18n>Nie udało się wysłać wiadomości, spróbuj jeszcze raz.</p>
				  <p class="info success" *ngIf="res === 1" i18n>Twoja wiadomość została wysłana, dziękujemy.</p>
				  <div class="flx-row flx-strt-cntr flx-gap-default">
					<button class="flat-button primary fat" (click)="submit()"  [disabled]="sent || loading" i18n="@@send">wyślij wiadomość</button>
					<div *ngIf="loading" class="loader-circle"></div>
				  </div>	
			  </form>
			</div>
		</div>

		<div class="map" *ngIf="isBrowser && mapLoaded$ | async">
			<google-map
			width="100%"
			height="100%"
			[zoom]="zoom"
			[center]="center"
			[options]="options"
			>
			<map-marker [position]="center"></map-marker>
			</google-map>
		</div>

	</div>
</div>